/**
 * Pilot body — mounts the Sandbox view + the three modals.
 *
 * F18 of the Oatmeal rebuild (`docs/eng/pilot-oatmeal-rebuild.md`)
 * split the three previously-inlined modals into per-modal files
 * (PilotChangeProcessModal, PilotEmailModal, PilotTalkModal), so
 * this file is now a small shell. Pitch / Demo / Vision are
 * conditionally mounted by Pilot.tsx on viewMode and don't pass
 * through here; Story is also mounted directly by Pilot.tsx.
 *
 * Every modal's `id` and inner `id`s are preserved verbatim because
 * the surviving engine modules (main.js, claude.ts, email.ts,
 * lead-api.ts) bind against them via getElementById / querySelector.
 */

import React from 'react';
import Sandbox from './Sandbox';
import PilotChangeProcessModal from './PilotChangeProcessModal';
import PilotEmailModal from './PilotEmailModal';
import PilotTalkModal from './PilotTalkModal';

export default function PilotBody() {
  return (
    <>
      {/* NOTEBOOK — Sandbox results, race, savings, knobs, talk CTA */}
      <Sandbox />

      {/* Pitch / Demo / Vision are conditionally mounted by Pilot.tsx
          on viewMode change (Phases 4 + 5 of the Oatmeal rebuild —
          each view's deck/canvas + chrome lives in a single component
          owned by Pilot.tsx, not PilotBody). */}

      {/* MODALS — each its own component since F18 of the Oatmeal
          rebuild. Engine modules still drive their open/close state
          via the legacy `.modal-backdrop.open` toggle on the outer
          modal id. */}
      <PilotChangeProcessModal />
      <PilotEmailModal />
      <PilotTalkModal />
    </>
  );
}
